import React from 'react'
import './Loader.css'
const Loader = () => {
  return (
   
    <div className="bg_white75p h-100 position-fixed px_loader top-0 start-0 w-100 loder_js  ">
    <div className="d-flex align-items-center justify-content-center w-100 h-100">        
<p  id='loaderTxt'>  </p>
<span className="loader"> </span>
    </div> 
</div>


  )
}
export default Loader



